import React from 'react'

import type { TagProps } from '@interco/inter-toranja/dist/types/shared'
import { ListItem as ListItemCard } from '@/components/ListItem'
import { useActionHandler } from '@/hooks/useActionHandler'
import { useHomeCreditListItemTag } from '@/hooks/useHomeCreditListItemTag'

import Carousel from '../../Carousel'
import * as S from './styles'

interface CarouselListItemProps {
  items: CarouselListItemData[]
  style?: { marginTop?: string; marginBottom?: string }
}

export const CarouselListItem: React.FC<CarouselListItemProps> = ({ items, style }) => {
  const { dispatchAction } = useActionHandler()
  const fireListItemTag = useHomeCreditListItemTag()

  return (
    <S.ContainerCarouselListItem style={style}>
      <Carousel gap={0} padding={16}>
        {items.map((item) => (
          <div key={item.id} style={{ width: '230px' }}>
            <ListItemCard
              label={item.props.title}
              paragraph={item.props.description}
              onTag={(tag: TagProps) => fireListItemTag(tag, item.props.title)}
              onClick={() => dispatchAction(item.props.action, item.props.analytics)}
            />
          </div>
        ))}
      </Carousel>
    </S.ContainerCarouselListItem>
  )
}
